import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import cx from 'classnames';
import Icon from '../../../atoms/FontIcon';
import s from './styleButton.module.scss';
var StyleButton = /*#__PURE__*/function (_React$Component) {
  _inherits(StyleButton, _React$Component);
  var _super = _createSuper(StyleButton);
  function StyleButton() {
    var _this;
    _classCallCheck(this, StyleButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onToggle", function (e) {
      var _this$props = _this.props,
        style = _this$props.style,
        onToggle = _this$props.onToggle;
      e.preventDefault();
      onToggle(style);
    });
    return _this;
  }
  _createClass(StyleButton, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        active = _this$props2.active,
        buttonClassName = _this$props2.buttonClassName,
        icon = _this$props2.icon,
        label = _this$props2.label;
      return /*#__PURE__*/React.createElement("span", {
        className: cx(s.btn, buttonClassName, _defineProperty({}, s.active, active)),
        onMouseDown: this.onToggle,
        role: "button",
        tabIndex: "-1"
      }, icon !== '' ? /*#__PURE__*/React.createElement(Icon, null, " ", icon, " ") : __(label));
    }
  }]);
  return StyleButton;
}(React.Component);
export default StyleButton;